require("vuetify/src/stylus/app.styl");

import Vue from "vue";
import VApp from "vuetify/es5/components/VApp";
import VBtn from "vuetify/es5/components/VBtn";
import VCard from "vuetify/es5/components/VCard";
import VToolbar from "vuetify/es5/components/VToolbar";
import VLayout from "vuetify/es5/components/VGrid";
import VList from "vuetify/es5/components/VList";
import VMenu from "vuetify/es5/components/VMenu";
import VIcon from "vuetify/es5/components/VIcon";
import VDivider from "vuetify/es5/components/VDivider";
import VAutocomplete from "vuetify/es5/components/VAutocomplete";
import VTextField from "vuetify/es5/components/VTextField";
import VTextarea from "vuetify/es5/components/VTextarea";
import VTabs from "vuetify/es5/components/VTabs";
import VExpansionPanel from "vuetify/es5/components/VExpansionPanel";
import VNavigationDrawer from "vuetify/es5/components/VNavigationDrawer";

import VDialog from "vuetify/es5/components/VDialog";
import Vuetify from "vuetify/es5/components/Vuetify";
import transitions from "vuetify/es5/components/transitions";
import * as directives from "vuetify/es5/directives";

Vue.use(Vuetify, {
  components: {
    VApp,
    Vuetify,
    VBtn,
    VCard,
    VToolbar,
    VLayout,
    VMenu,
    VList,
    VIcon,
    VDivider,
    VAutocomplete,
    VTextField,
    VTextarea,
    VTabs,
    VExpansionPanel,
    VNavigationDrawer,
    VDialog,
    transitions
  },
  theme: {
    primary: "#4385f3",
    secondary: "#0288D1",
    accent: "#D81B60",
    error: "#DD2C00",
    warning: "#FF9100",
    info: "#2196f3",
    success: "#4caf50",
    grey: "#FAFAFA",
    darkGrey: "#9c9c9c",
    pink: "#ff4081",
    spiceBlue: "#293896",
    spiceRed: "#ed2027",
    fb: "#3B5998"
  },
  directives
});
